<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="75px" height="75px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
    <image id="image0" width="100" height="100" x="0" y="0" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
      AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACxFBMVEUAAAD/hAD/hgD/hQD/
      hAD/kQD/hQD/hwD/hQD/hgD/hQD/hgD/hQD/hQD/hgD/hQD/hQD/hwD/hgD/fwD/gwD/hgD/hgD/
      hgD/hQD/mQD//wD/hwD/hgD/hgD/hQD/fwD/hgD/hQD/hQD/hgD/iAD/hgD/hgD/hgD/hwD/hwD/
      hwD/jAD/qgD/hwD/hAD/hgD/hwD/hQD/hQD/hgD/hgD/hgD/gwD/hQD/hgD/hAD/iQD/iAD/hQD/
      hQD/hgD/hgD/hgD/gwD/hQD/hgD/hgD/fwD/hgD/hgD/hgD/hgD/hwD/hgD/hQD/hgD/hQD/hgD/
      hQD/hQD/hgD/hgD/hQD/fwD/hQD/hQD/hgD/hQD/hQD/hQD/hgD/hgD/hgD/hQD/hgD/hwD/hQD/
      hQD/hQD/hQD/iAD/ggD/hQD/hQD/hgD/hQD/hQD/hQD/hQD/hQD/hQD/hQD/jQD/hgD/hQD/gwD/
      hgD/hQD/hgD/hQD/hgD/hQD/hgD/fwD/hwD/hQD/hwD/hQD/hQD/hQD/hgD/hAD/hQD/fwD/hQD/
      hgD/hQD/hgD/hAD/hQD/hQD/hgD/iAD/hwD/hgD/fwD/hgD/hQD/hgD/hgD/hQD/hgD/iwD/hAD/
      hgD/hQD/hQD/hgD/hgD/hQD/hQD/hQD/iAD/hgD/hgD/hgD/hAD/hgD/hQD/hwD/iwD/hQD/hAD/
      hQD/hgD/hQD/hQD/hQD/iAD/igD/hgD/hgD/hQD/hgD/hwD/hQD/hgD/hAD/hQD/hgD/hAD/hgD/
      hgD/hgD/hAD/hgD/hQD/hQD/hQD/hQD/iAD/gwD/hwD/hgD/hgD/hgD/hQD/hgD/hQD/hQD/hgD/
      hgD/hQD/hQD/hAD/hQD/iQD/hgD/hQD/hgD/hgD/hQD/hgD/hQD/hQD/hgD/hQD/hAD/hQD/hgD/
      hgD/fwD/hgD////AJzMwAAAA6nRSTlMAS+TjSQcuVXylxtHd7vnSpC/iBDq+9307BQFAn/FBAoHf
      4YUc6LyQZDMiFAMRGyZEZYav5poj8KtiGh5You37ox+g9XkG3HQT10JGm13+iuxpxUhFEpHpWW1a
      eLb9btbAUeWAs7stJypxkvqN9utQ9NsJV0MdJFLEKH+IshB3lyCx8lShdWMIt+qZ82D4ftUrT0wO
      2oS43mfgCzBOFZ5w7+ePPQ+HOa0ye6YxFlxewc+/qtA8GLS6i6lmtcJHw2EZW4xqTV/ZqHpWKSE+
      2KeO/M2VsInHP842Fw1sc8uYdsnI1HKuOL2WSgziHeE3AAAAAWJLR0Trv90muAAAAAlwSFlzAAAL
      EwAACxMBAJqcGAAAAAd0SU1FB+kHGRADK/kZLRwAAAoGSURBVGje7Vr7X1THFR8eqxvB1bJC3OWl
      G7EJL61irKi7Cq5RwO2SlfgEEaom6OoGkgipJgSoRlGgUsFHIL6SqHnHRxPTpppEE02srUltbdqm
      te/7V3TOzL1z79w79+4K+fTz6eeT84POmTlzvzNznjMLQt/S/w3FxSckannbiJH2e0YlJY92OEYn
      jxk11j7yO7ZhgyRIUorSdo6zp6ZJBkpLvXe8a1gg8BXScKdnZEqmlJmRlT18kAkTpSjkuW/ScEHY
      t3Imf/f+rAdy82z5BYVTpn5v2vQiNuSY8eA3ADLz+7OKjSKz58z1yjC+efOHB5JWkmWqXmeWspvS
      Bf6hgyx8aFFUOUqLy4YMYmU7zvKKHJBbspCgBH7gHCKIFUJQ3gNyVVLlPDz7mwUJ5agHhdlFFQFo
      BZfeBUTVIzDlkSpTAdsyiQPBqPHEmpfHCuFaIZumd4WZXa0k48GKVT5JipcXthq6qmtiwwitURe5
      JiSWqcVjk8uxotfG18XJfdn15MjqY4CY8kM+aqxbLxDaAJ971NA9koTRx6Iqo2GjPjZtbDCqZhPu
      rxVMn1oKJ2atF6aMMDnf1WET1dg2496VsPRg3RZuJD0C2reysUSqjMcbQo3UhBtDDY9T1XAJjKg9
      iHOWG4P5mrihJxww9qQ5CNnCiqeUNjXNp1aQDXGCoPZN0ABD9m3lxpaDuprNfZ9sQQVkH4YNaeVa
      8HcCLdDaii1YMWGFnoapP0KxkJXHg9qbaXMVZBp+NHsbxLH04YKAbwdqV0IhUYGbFbrh7QmgxVgi
      vxVIAjW64KYWF8TIcv34E6CWZ0wm26amxwQSUgJXYAxgGUPPs7g7IorIrZXPRdpYkq0XBQjmFbaV
      tQHmrPS04kh89LYTpgBW0WHEeBDs5Mcchh6F84qWTUo2Kdce4Wg6ugNMO9cAAhr0+HkMPQrxCuZ7
      O58nIhE/O15Mu9yEy1+M27v1GMXgqJV6DB0K8QoFZf46ItC5B2lAfO3KyWJmr74e6wKnUopb3O6u
      7+mp79Yrv4mg/ASa+9pojJZLoV6KwbaZ/VPM7ucxnHCkkR6Zwwi0gXE4sd4++FQ/fISUdm0H6On0
      2r08BkKVmD/IVyHlZCHdh5AlLaUxGkAOa7fxghy76wZU2UOduCOLmz5IpTKsQZJp4IdA/iJuPO+W
      +1nBmurkPznIndYRWWoP6woNDia6BSBeey80p+Pmi1tzjhKOQE+Gf4+pwlBbZmr99Dh0dGvVguC6
      cEIHMjV5IYVA2XBAL/lkUPh8rzMV/lvChPPBj17WzN6P+Vd6Ilq1eDDTanpwRCXVct600xA0AFPC
      J5lMB2ZPaeY0Y/5+tAeET8tdSbj9qinIY/pCAEz9MCR4z2uKzOuYm6xOcYXpsjNA+g3a9yZumlXQ
      zvK3ZN+b4dWAoCXQeLs9ZWINGMB8zKSp98oHIB7g/w+BWibSvndwc4cYgdXA2C9kD5Gd9pgCeeYs
      ouFMrafewFwfMSk1z03gbYVR+VF2QtT3KEw/XUCqMhboOIfO4//b2cT7wFSgAdY/nfY14ebPBCDJ
      OgwC098vF0EDdWx4Zs27nObfw9wFaBDrp33rcbNIANJvwNASDW7v02QDmp7Lhn6OuV8g2foP0z4b
      VJKC8ukFn2y4a00xmtDxJGUpH7AxiJhQ4YD1e5WgNgozvzT7kOz3JhhYOTUzKUgSGwRrucirhDro
      PSLzWnu0SAihwcB0riOgBFNKETmEnFdVglAZWJobWdMlVdEGTZ09g/nNjIUVuNChEklVCc6uoLeT
      lhDOY5I5BkJ+yI6Mg9Sb3wOeKBWpeQZS+IdWGAOplhjIBT2cTj6CwCOVfqzKXMZ8vMUN+6RHj5HC
      XyO2465OxrE3mu4ejUxv2CJ84UBFLi8eiwMtlKMVpTEyRgmffiF8DZp8QFZH6oA5BmrBAlcY10wm
      lO7RCa0Fr82zUscxyycIKBzeZNxYw1ER8oN92s3VEX4dWdIFLPMJ4+6FjQsqlU/B3ARXgDiijoPW
      9o3QNElbel3F3HMCqUVgcZeN/Z6o6iAEl6FLjBuBuQSR2G48sCbf0B1dHYTg9UXN4DvT5OClp2vV
      wvzIMqElQfoNa2qiVG5jGpoLLrZzaCCXuEhPNS+sHj+DiPPQ0EBOK/lWpvGKy+dUlPNn3YA7g3pf
      iQnECRnwc02Hq00NQEEO57VOwSZjAoEy9Qi34gzJSEUkWIKv6C/lMYF0cBkeqEwAInkh//khAyy2
      GUCaomCcAB/jL9/ZHlKwaAo3SQkpZyGN8nfHBF3q2JKg3Tulj4DXuRiUXtcheSjPsGwr5Mrq05bn
      aIuPQ2nyKROWMbdwwivuBN3uJoGtanNOr1fZShWA9nPXCK5kUDE05wPVtuOi/gxn4N4x2u3Z2VYS
      4cB+hUxQtBjsmSUfXs6MrwXksWCWcCvohqQb032awkH6UJ5AQCO/nmI0h3mQ0rX1lLoV229wM22c
      KQrdkuYxZ5HXYL+U5oPN3RRvZQO45K5cExRFOWAhp0mlBtG7VPhEuACPVB/XbUXOAHNALWu2c/Jb
      UnQ1Crmnw7U7BNJdIgzkh/eQiQVqRyLm6+R2F/mA9c9kLvJC1XYgD9L2dXhoFNQ6ZbCAL9TKVPsq
      5waVSdOtn+M+piEQdFM9HvOtbwmEvgSRBWxh3Kuc7QMY3GaNIj/qYHoX2C+8ov0+DNFQ8WStSWLK
      uwKTz1v/guk+QDfzW5jXLqWJZGaDQaXdMp4WUPF1mL46yvsLuLq0GR5dioNSRCiyFKJLJ001Ofow
      ehEsQ/qd5a+Kn4OxO8BG3X2SlCkWWg6lQyfJH/BFPk2eo4X/76NgBEgV1SNpr0A81cB39i5HwtR0
      m1TN4TlmGHPITxv0HtWOW2+bCZK3wYDdLcx/fzhPRm82ima67eQG9ynloDgxK9cR+oo8zKy7LUyy
      bvo+uVhQom7/hCzgjzJbK8n3dhO9OEi0MMnkO8io4xn99SiLpEeH/DSDimGp18xB0FKWg0WjZw+S
      oT9xUbnqz2T/u1js+xpzVyzvtU82yyDC29wJEmKkwNhC1hXaRbr+0qp03Ia3wK+RJTm/pC8XSVuF
      i7lKn4YiXSycbqic8deDH6pBB9bRFrXuT5d/B7xzQOTihdvoaOcN8Q+xf9OYmRW5VkXoh45U3BKc
      WvkdOrpxXpbhbuGaRpbXGB0ER7IOJfktK2kq1I86v1LMI+cmt4rsOHiKkGZOiQUD02e797JEnvL3
      aZfLHs0rQP6CXBqbq7rYD8BH3n+6/dXcqsbCf1ytoJ2Zt2LEwDRpv+FJABKxnPJ2XrguiSk+2oWS
      p+z0QcGflLzXKo/uGysYrb7Ze1cY5PjHnfqn/o9jHA3K26xtX8lmbijzX+vvGoKSf0T7qbnNZ5K9
      5M98mktOXdUo1n1t1o2+JE9muO5O34R//2eIEN/S/5D+C+P55BrA5eGcAAAAJXRFWHRkYXRlOmNy
      ZWF0ZQAyMDI1LTA3LTI1VDE2OjAzOjQzKzAyOjAwajgO7AAAACV0RVh0ZGF0ZTptb2RpZnkAMjAy
      NS0wNy0yNVQxNjowMzo0MyswMjowMBtltlAAAAAASUVORK5CYII="
    />
  </svg>
</template>

<script>
export default {};
</script>
